import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft } from 'ramda'
import React from 'react'

import { serviceOrdersClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrdersCounterState = () => React.useContext(Context)
export const useServiceOrdersCounter = () => useServiceOrdersCounterState()?.serviceOrdersCount
export const useAllServiceOrdersCounter = () => useServiceOrdersCounterState()?.all

const QUERY = gql`
  query ServiceOrdersCount($filter: ServiceOrderFilter, $fixedFilter: ServiceOrderFilter) {
    serviceOrdersCount(filter: $filter)
    all: serviceOrdersCount(filter: $fixedFilter)
  }
`

const ServiceOrdersCounterLoader = ({ widget, children }) => {
  const widgetFilter = clearFilterParams(widget.data?.filters || []) || {}
  const ignoreDate = widget?.data?.ignoreDate
  const { date, ...manualFilter } = useCleanFilterForRequest() || {}
  const insertedAt = !ignoreDate ? date : undefined
  const fullFilter = mergeDeepLeft(widgetFilter, manualFilter)

  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { ...fullFilter, insertedAt }, fixedFilter: { ...manualFilter, insertedAt } },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersCounterLoader
